import React, {Component} from 'react';
import {Nav, NavItem} from "reactstrap";
import {NavLink} from "react-router-dom";
import appRoutes from "appRoutes";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import NavigationAdmin from './NavigationAdmin';
import {connect} from "react-redux";

class NavigationAdminSettings extends Component {
  render() {
    const {user} = this.props;

    return (
      <Nav className="navbar-nav m-0 mx-lg-5 align-items-lg-baseline w-50 w-lg-100 float-right d-inline-block d-lg-flex">
        {user.roles.includes('ROLE_SUPER_ADMIN') && <NavItem className="py-2"><NavLink exact className="nav-link" to={appRoutes.admin.settings.codes} onClick={() => NavigationAdmin.toggleNavbar(true)}><FormattedMessage id="navigation.adminSettings.codes" /><span className="sr-only"><FormattedMessage id="navigation.adminSettings.codes" /></span></NavLink></NavItem>}
        {user.roles.includes('ROLE_SUPER_ADMIN') && <NavItem className="py-2"><NavLink className="nav-link" to={appRoutes.admin.settings.plans.list} onClick={() => NavigationAdmin.toggleNavbar(true)}><FormattedMessage id="navigation.adminSettings.plans" /><span className="sr-only"><FormattedMessage id="navigation.adminSettings.plans" /></span></NavLink></NavItem>}
        {(user.roles.includes('ROLE_SUPER_ADMIN') || user.roles.includes('ROLE_ADMIN_PLANS')) && <NavItem className="py-2"><NavLink className="nav-link" to={appRoutes.admin.settings.planCategories.list} onClick={() => NavigationAdmin.toggleNavbar(true)}>Plany wyświetlanie</NavLink></NavItem>}
        {user.roles.includes('ROLE_SUPER_ADMIN') && <NavItem className="py-2"><NavLink className="nav-link" to={appRoutes.admin.settings.configurations} onClick={() => NavigationAdmin.toggleNavbar(true)}><FormattedMessage id="navigation.adminSettings.configurations" /><span className="sr-only"><FormattedMessage id="navigation.adminSettings.configurations" /></span></NavLink></NavItem>}
        {user.roles.includes('ROLE_SUPER_ADMIN') && <NavItem className="py-2"><NavLink className="nav-link" to={appRoutes.admin.settings.userEmailDomainBlacklist} onClick={() => NavigationAdmin.toggleNavbar(true)}>Zablokowane domeny</NavLink></NavItem>}
      </Nav>
    );
  }
}

NavigationAdminSettings.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps)(NavigationAdminSettings);
